export type RenderPriceProps = {
  basePrice?: string;
  strikethroughPrice?: string;
  isFlightEnabled: boolean;
  transitionDelay?: number;
  isLoading?: boolean;
};

export enum OrderByTypeEnum {
  CABIN = 'cabin',
  PERSON = 'person',
}
